import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import { setWasmUrl } from "@lottiefiles/dotlottie-react";
import App from "./App";
import "./index.css";

// Initialize Sentry for pure error logging
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
});

// Self-host the dotlottie WASM to avoid CSP violations from CDN fetches
setWasmUrl("/dotlottie-player.wasm");

// StrictMode is a dev-only diagnostic: it double-invokes renders and effects
// to surface effects that aren't safe to re-run. That also doubles every
// mount-time fetch (share token, run list, session creation), which makes
// local QA of the real request flow and of Dispatch's rate limit misleading.
// It stays on by default; set VITE_STRICT_MODE=0 in .env.local for a
// production-like session. Production builds strip StrictMode regardless.
const strictMode = import.meta.env.VITE_STRICT_MODE !== "0";
const app = <App />;

createRoot(document.getElementById("root")!).render(
  strictMode ? <StrictMode>{app}</StrictMode> : app,
);
